import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.css";
import instagramIcon from "../../assets/images/instagram.png";
import whatsappIcon from "../../assets/images/wsp.png";
import Nosotros from "./Nosotros";
import Tecnologia from "./Tecnologia";
import Ubicacion from "./Ubicacion";
import Reserva from "./Reserva";
import Especialidades from "./Especialidades";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header row">
      <div className="container">
        <div className="col-12 menus">
          {/* Móvil: logo y hamburguesa */}
          <div className="nav-no-mobile">
            <Link to="/">
              <img style={{ paddingTop: "20px" }} src="/assets/images/caima.png" alt="Logo CAIMA" className="logo-image" />
            </Link>
          </div>
          <div className="nav-mobile">
            <button
              className="hamburger-menu"
              onClick={toggleMenu}
              aria-label="Menú"
              aria-expanded={isMenuOpen}
              style={{ margin: "0px" }}
            >
              <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
              <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
              <span className={`hamburger-line ${isMenuOpen ? "open" : ""}`}></span>
            </button>
            <Link to="/" onClick={() => setIsMenuOpen(false)}>
              <img src="/assets/images/caima.png" alt="Logo CAIMA" className="logo-image" style={{ paddingRight: "40px" }} />
            </Link>
          </div>

          {/* Escritorio: navegación completa */}
          <div className="nav-der desktop-only">
            <nav>
              <ul style={{ textTransform: "uppercase" }}>
                <li><Nosotros /></li>
                <li><Tecnologia /></li>
                <li><Especialidades /></li>
              </ul>
            </nav>
          </div>
          <div className="nav-izq desktop-only">
            <nav>
              <ul>
                <li><Ubicacion /></li>
                <li><Reserva /></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>

      {/* Menú móvil desplegable */}
      <div className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
        <nav>
          <ul>
            <li>
              <Link to="/" onClick={toggleMenu}>Inicio</Link>
            </li>
            <li><Nosotros onClick={toggleMenu} /></li>
            <li><Tecnologia onClick={toggleMenu} /></li>
            <li><Especialidades onClick={toggleMenu} /></li>
            <li><Ubicacion onClick={toggleMenu} /></li>
            <li className="reserva-mobile"><Reserva onClick={toggleMenu} /></li>
            <li className="social-icons">
              <a href="https://instagram.com/caimadental" target="_blank" rel="noopener noreferrer">
                <img src={instagramIcon} alt="Instagram" className="icon-image" />
              </a>
              <a href="https://wa.me/56912345678" target="_blank" rel="noopener noreferrer">
                <img src={whatsappIcon} alt="WhatsApp" className="icon-image" />
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
